<span class="academy-badge"
  [ngClass]="cssClass"
  role="status"
  [attr.aria-label]="displayText">
  @if (type === 'failed') {
    <svg class="badge-failed-icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M7.5 4.5L4.5 7.5M4.5 4.5L7.5 7.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  }
  {{ displayText }}
</span>
